import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {BackendApi, localhost} from '../config/backend-api';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private httpClient: HttpClient,
              private router: Router) {}

  public editProfile(editForm) {
    return this.httpClient.post(localhost + BackendApi.EDIT_PROFILE, editForm, {responseType: 'json', observe: 'response'});
  }

  public updateChatNotification(value) {
    return this.httpClient.post(localhost + BackendApi.EDIT_CHAT_NOTIFICATION, value, {responseType: 'json', observe: 'response'});
  }
}
